import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { UpdateProjectBriefAnswerParams } from '@/shared/api/end-points/project'
import { methods } from '@/shared/api/constants'
import { ProjectBriefAnswer, UpdateProjectBriefAnswerPayload } from '../../lib'

const updateProjectBriefAnswer = async ({
  answerId,
  ...payload
}: UpdateProjectBriefAnswerParams & UpdateProjectBriefAnswerPayload) => {
  return await api.json<ProjectBriefAnswer>(API_END_POINTS.project.updateProjectBriefAnswer({ answerId }), {
    method: methods.patch,
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export default updateProjectBriefAnswer
